// assets
import {
  IconBook,
  IconChecklist,
  IconCalendarEvent,
  IconCalendarTime,
  IconClockPlus,
  IconClipboardCheck,
  IconFileCheck,
  IconId,
  IconLibrary,
  IconListCheck,
  IconProgress,
  IconReportAnalytics,
  IconRoute,
  IconSchool,
  IconWritingSign
} from '@tabler/icons-react';

// types
import { NavItemType } from 'types';

// ==============================|| MENU ITEMS - EDUCATION (S-20) ||============================== //

const education: NavItemType = {
  id: 'education',
  title: 'education', // react-intl key (utils/locales/en.json) - i18n-ready [STD-DRIFT]
  icon: IconSchool,
  type: 'group',
  requiredModule: 'learning',
  children: [
    {
      id: 'education-courses',
      title: 'education-courses',
      icon: IconBook,
      type: 'item',
      url: '/education/courses',
      // PA-7: module-derived — any action on learning.courses lights up the menu (view/add/… granted
      // via the taxonomy matrix), instead of pinning to the legacy `learning.courses.read` code.
      module: 'learning.courses'
    },
    {
      // QUIZ (mig 586): course quizzes — exam rows of kind 'quiz', authored here and linked from a course lesson.
      id: 'education-quizzes',
      title: 'education-quizzes',
      icon: IconChecklist,
      type: 'item',
      url: '/education/quizzes',
      module: 'exam.exams'
    },
    {
      // LRN-LIB (mig 596): every file courses use; lessons point at its items. Course editors only.
      id: 'education-library',
      title: 'education-library',
      icon: IconLibrary,
      type: 'item',
      url: '/education/library',
      permission: 'learning.courses.update'
    },
    {
      id: 'education-enrollments',
      title: 'education-enrollments',
      icon: IconProgress,
      type: 'item',
      url: '/education/enrollments',
      permission: 'learning.enrollments.read_all' // admin izleme ekranı — öğrenci personası görmez
    },
    {
      id: 'education-exams',
      title: 'education-exams',
      icon: IconFileCheck,
      type: 'item',
      url: '/education/exams',
      module: 'exam.exams'
    },
    {
      id: 'education-question-banks',
      title: 'education-question-banks',
      icon: IconListCheck,
      type: 'item',
      url: '/education/question-banks',
      module: 'exam.questions'
    },
    {
      // EXTRA-TIME (mig 529): admins only by default — an arrangement usually reveals a disability or SEN.
      id: 'education-exam-arrangements',
      title: 'education-exam-arrangements',
      icon: IconClockPlus,
      type: 'item',
      url: '/education/exam-arrangements',
      module: 'exam.arrangements'
    },
    {
      id: 'education-grading',
      title: 'education-grading',
      icon: IconWritingSign,
      type: 'item',
      url: '/education/grading',
      permission: 'exam.attempts.grade' // öğretmen puanlama ekranı
    },
    {
      id: 'education-events',
      title: 'education-events',
      icon: IconCalendarEvent,
      type: 'item',
      url: '/education/events',
      module: 'engagement.events'
    },
    {
      id: 'education-appointments',
      title: 'education-appointments',
      icon: IconCalendarTime,
      type: 'item',
      url: '/education/appointments',
      module: 'engagement.appointments'
    },
    {
      id: 'education-attendance',
      title: 'education-attendance',
      icon: IconClipboardCheck,
      type: 'item',
      url: '/education/attendance',
      module: 'engagement.attendance'
    },
    // RPT (mig 265): per-event READ-ONLY reports. `module` (not `permission`) so the derived Menu
    // grant lights them up for any role given view or print via the Roles matrix.
    {
      id: 'education-passport-visa-report',
      title: 'education-passport-visa-report',
      icon: IconId,
      type: 'item',
      url: '/education/passport-visa-report',
      module: 'engagement.passport_visa_report'
    },
    {
      id: 'education-travel-report',
      title: 'education-travel-report',
      icon: IconRoute,
      type: 'item',
      url: '/education/travel-report',
      module: 'engagement.travel_report'
    },
    // EVR (mig 374): the Event Report module — an event list, each row opening a tabbed per-event report.
    // `module` (not `permission`) for the same reason as the two reports above: the derived Menu grant
    // lights it up for any role given view OR print through the Roles matrix.
    //
    // ⚠ SEEING THE ENTRY IS NOT BEING ABLE TO READ THE REPORT. Permissions are ALL-OF, so the pages still
    // need engagement.events.view (list) and engagement.registrations.view (roster); the pages say which
    // grant is missing rather than rendering blank. See mig 374's header.
    {
      id: 'education-event-report',
      title: 'education-event-report',
      icon: IconReportAnalytics,
      type: 'item',
      url: '/education/event-report',
      module: 'engagement.event_report'
    },
    // EXAM-REPORT: one row per student × exam (latest attempt). `permission`, like Grading beside it: the read
    // itself demands exam.attempts.grade, so showing the entry to anyone else would open a 403.
    {
      id: 'education-exam-report',
      title: 'education-exam-report',
      icon: IconReportAnalytics,
      type: 'item',
      url: '/education/exam-report',
      permission: 'exam.attempts.grade'
    }
  ]
};

export default education;
